import { Link } from 'react-router-dom';

const footerLinks = {
  categories: {
    title: '热门分类',
    links: [
      { label: '平台介绍', to: '/category/platform-intro' },
      { label: '使用指南', to: '/category/usage-guide' },
      { label: '功能教程', to: '/category/feature-tutorial' },
      { label: '最新动态', to: '/category/latest-news' },
      { label: '常见问题', to: '/category/faq' },
    ],
  },
  articles: {
    title: '推荐阅读',
    links: [
      { label: '成91平台全面介绍', to: '/article/cheng91-platform-introduction' },
      { label: '快速上手教程', to: '/article/cheng91-quick-start-guide' },
      { label: '高级功能介绍', to: '/article/cheng91-advanced-features' },
      { label: '安全保障与隐私', to: '/article/cheng91-security-privacy' },
    ],
  },
  contact: {
    title: '联系我们',
    links: [
      { label: '客服邮箱：support@cheng91.com', to: 'mailto:support@cheng91.com' },
      { label: '客服热线：400-123-4567', to: 'tel:4001234567' },
    ],
  },
};

export default function Footer() {
  return (
    <footer className="bg-background-800 text-background-100">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="sm:col-span-2 lg:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <span className="text-background-50 font-bold text-lg">91</span>
              </div>
              <span className="font-heading font-bold text-xl text-background-50">成91</span>
            </Link>
            <p className="text-background-300 text-sm leading-relaxed mb-4">
              成91是备受关注的热门平台，致力于为用户提供优质、便捷的数字化服务体验。汇聚丰富资源，持续创新升级。
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-700 hover:bg-background-600 text-background-200 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-700 hover:bg-background-600 text-background-200 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a href="mailto:support@cheng91.com" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-700 hover:bg-background-600 text-background-200 transition-colors cursor-pointer" aria-label="邮箱">
                <i className="ri-mail-line text-lg"></i>
              </a>
            </div>
          </div>

          {/* Link columns */}
          {[footerLinks.categories, footerLinks.articles, footerLinks.contact].map((col, idx) => (
            <div key={idx}>
              <h4 className="text-background-50 font-semibold text-sm mb-4">{col.title}</h4>
              <ul className="flex flex-col gap-2.5">
                {col.links.map((link, linkIdx) => (
                  <li key={linkIdx}>
                    {link.to.startsWith('mailto:') || link.to.startsWith('tel:') ? (
                      <a
                        href={link.to}
                        className="text-background-400 hover:text-background-100 text-sm transition-colors cursor-pointer"
                        rel="nofollow"
                      >
                        {link.label}
                      </a>
                    ) : (
                      <Link
                        to={link.to}
                        className="text-background-400 hover:text-background-100 text-sm transition-colors cursor-pointer"
                      >
                        {link.label}
                      </Link>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom bar */}
        <div className="border-t border-background-700 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-background-500 text-xs">
            &copy; 2026 成91平台 版权所有 | 京ICP备XXXXXXXX号
          </p>
          <div className="flex items-center gap-4 text-background-500 text-xs">
            <Link to="/about" className="hover:text-background-300 transition-colors cursor-pointer">隐私政策</Link>
            <Link to="/about" className="hover:text-background-300 transition-colors cursor-pointer">服务条款</Link>
            <Link to="/about" className="hover:text-background-300 transition-colors cursor-pointer">联系我们</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}